import { Link as RouterLink } from 'react-router-dom';
import styled from '@emotion/styled';

export const Link = styled(RouterLink)`
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
`;
